import React from "react";
import Navbar from "../headers_footer/navbar";
import Flexproducts from "./flexproducts";
import Header from "../headers_footer/header";

const BathBody = () => {

return (

<div>

<Navbar />
<Flexproducts type="bathbody" />
<Header></Header>

</div>

);
};

export default BathBody;